import { FC } from 'react';

import { CouponHistorySection } from '../../components/giftSettlement/CouponHistorySection';
import { CouponPendingSection } from '../../components/giftSettlement/CouponPendingSection';
import { ROLE } from '../../utils/coupon-settlement.utils';

/**
 * 쿠폰형 정산 화면 본체 (상조관리자 — 읽기 전용).
 * 단독 페이지와 통합 정산 페이지의 '쿠폰형' 탭이 공유한다.
 * admin 페이지와 **완전 동일한 view**를 같은 섹션 컴포넌트로 그린다 (2026-07-02 결정).
 */
export const AgencyGiftCouponSettlementView: FC = () => (
  <div>
    {/* 미정산 내역 (상단) — view 전용 */}
    <section className="mb-10">
      <h2 className="mb-4 text-lg font-bold text-gray-800">미정산 내역</h2>
      <CouponPendingSection readOnly role={ROLE} />
    </section>

    {/* 정산 완료 내역 (하단) — 읽기 전용 목록 + 상세 모달 */}
    <section>
      <h2 className="mb-4 text-lg font-bold text-gray-800">정산 완료 내역</h2>
      <CouponHistorySection
        isAdmin={false}
        refreshTrigger={0}
        role={ROLE}
        hideBrandColumn
      />
    </section>
  </div>
);
